import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent {
  @Input() steps = 5;
  @Input() currentStep = 1;

  get stepsArray(): number[] {
    return Array.from({ length: this.steps }, (_, i) => i + 1);
  }
}
